import * as React from 'react'
import * as Redux from 'react-redux'

import { Status } from '@owl-nest/redux-wrapper'
import { Spinner, styles as S } from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'
import * as env from '@owl-nest/config'
import { t } from '@owl-nest/localize'
import { useLazyInitialLoad } from '@owl-nest/hooks'

import * as impactReducer from '../../../../../../reducers/impact'
import * as impactAction from '../../../../../../actions/impact'
import { ImpactBlock } from '../../../../../components/ImpactBlock'
import { RootState } from '../../../../../../reducers'
import { EditButton } from '../../../components/EditButton'
import { CreateButton } from '../../../components/CreateButton'

import * as Styles from '../../../style'
import * as ProjectTabStyles from '../style'

type ImpactProps = {
  editMode: boolean
}

export function Impact({ editMode }: ImpactProps): React.ReactElement<ImpactProps> {
  const dispatch = Redux.useDispatch()
  const impact = Redux.useSelector<RootState, impactReducer.State>((state) => state.application.impact)
  const { projectId, projectToken } = Redux.useSelector<RootState, { projectId: number; projectToken?: string }>(
    (state) => ({
      projectId: state.application.project.data.id,
      projectToken: state.application.project.token,
    }),
  )
  const userConfig = env.useUserEnv()

  const wrapperRef = React.useRef<HTMLDivElement>(null)
  useLazyInitialLoad({
    target: wrapperRef,
    load: () => {
      if (impact.status.load.status === Status.PRISTINE) {
        dispatch(impactAction.load(projectId, projectToken))
      }
    },
  })

  return (
    <div ref={wrapperRef}>
      {impact.status.load.status === Status.PENDING ? (
        <Spinner />
      ) : impact.data !== undefined && !model.impact.isEmpty(impact.data) ? (
        <Styles.SidebarItem>
          <ImpactBlock impact={impact.data} />
          {editMode && (
            <ProjectTabStyles.EditButtonWrapper>
              <EditButton link={`/projects/${projectId}/backoffice/impact/${userConfig.lang}/`} />
            </ProjectTabStyles.EditButtonWrapper>
          )}
        </Styles.SidebarItem>
      ) : (
        editMode && (
          <ProjectTabStyles.CreateButtonWrapper large={true}>
            <CreateButton
              center={true}
              createHandler={() => {
                document.location.href = `/projects/${projectId}/backoffice/impact/${userConfig.lang}/`
              }}
              direction={'column'}
              mode="small"
              title={
                <S.heading.XS>{t('What is this project’s positive impact and what are its hurdles?')}</S.heading.XS>
              }
            />
          </ProjectTabStyles.CreateButtonWrapper>
        )
      )}
    </div>
  )
}
